module.exports = __webpack_public_path__ + "img/yinhead.bd588c08.png";